import { render } from "./EgoHeader.vue?vue&type=template&id=3e9ec87d&scoped=true&ts=true"
import script from "./EgoHeader.vue?vue&type=script&lang=ts"
export * from "./EgoHeader.vue?vue&type=script&lang=ts"

import "./EgoHeader.vue?vue&type=style&index=0&id=3e9ec87d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\arind\\Documents\\scm\\easynwk-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9ec87d"]])

export default __exports__